import { useEffect, useRef } from "react";
import { css } from "@emotion/react";

const Trailer: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playRef = useRef<HTMLImageElement>(null);
  const thumbnailRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      // 演奏中はplayボタンを非表示にする
      videoRef.current.addEventListener("play", () => {
        if (videoRef.current) {
          videoRef.current.controls = true;
        }
        if (playRef.current) {
          playRef.current.style.display = "none";
        }
        if (thumbnailRef.current) {
          thumbnailRef.current.style.display = "none";
        }
      });
      // 停止中はplayボタンを表示する
      videoRef.current.addEventListener("pause", () => {
        if (videoRef.current) {
          videoRef.current.controls = false;
        }
        if (playRef.current) {
          playRef.current.style.display = "block";
        }
      });
    }
  }, [videoRef.current]);

  useEffect(() => {
    if (playRef.current) {
      playRef.current.addEventListener("click", () => {
        if (videoRef.current) {
          videoRef.current.play();
        }
      });
    }
    return () => {
      if (playRef.current) {
        playRef.current.removeEventListener("click", () => {
          if (videoRef.current) {
            videoRef.current.play();
          }
        });
      }
    };
  }, [playRef.current]);

  return (
    <div css={mainStyle} id="trailer">
      <div css={contentsWrapperStyle}>
        <div css={trailerBoxStyle}>
          {/* mp4形式の動画. 中央にボタンの画像を配置する */}
          <img
            ref={playRef}
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/play.png"}
            alt="play-button"
            css={playButtonStyle}
          />
          <video
            ref={videoRef}
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/ashigirl_PV.mp4"}
            css={videoStyle}
          ></video>
          <div ref={thumbnailRef} css={thumbnailWrapperStyle}>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH +
                "/img/video-thumbnail.png"
              }
              alt="thumbnail"
              css={thumbnailStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  background-color: #fff;
`;

const contentsWrapperStyle = css`
  padding: 30px 0;
  display: flex;
  justify-content: center;
`;

const trailerBoxStyle = css`
  position: relative;
  width: 300px;
  padding: 12.5px 10px;
  background: linear-gradient(
    to right,
    rgba(248, 204, 197, 0.63) 0%,
    rgba(250, 211, 202, 0.4) 33%,
    rgba(243, 170, 178, 0.54) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    width: 480px;
  }
`;

const playButtonStyle = css`
  z-index: 10;
  position: absolute;
  width: 50px;

  @media (min-width: 768px) {
    width: 80px;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const videoStyle = css`
  width: 300px;

  @media (min-width: 768px) {
    width: 480px;
  }
`;

const thumbnailWrapperStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 168.75px;
  background-color: #000;
  overflow: hidden;

  @media (min-width: 768px) {
    width: 480px;
    height: 270px;
  }
`;

const thumbnailStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110%;
  height: auto;
`;

export default Trailer;
